// JsFromRoutes CacheKey c25df95a0c04806581b28d0437662206
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  show: /* #__PURE__ */ definePathHelper('get', '/api/v1/user_targets'),
  create: /* #__PURE__ */ definePathHelper('post', '/api/v1/user_targets'),
}
